export const calculateBmi = (heightCm: string, weightKg: string) => {
  const height = Number(heightCm);
  const weight = Number(weightKg);

  if (!height || !weight) return "";

  return (weight / Math.pow(height / 100, 2)).toFixed(1);
};
